
import { Component, Vue } from 'vue-property-decorator';
import SvgIcon from '@/components/SvgIcon.vue';
import ImportBlockForm from '@/components/Forms/Blocks/ImportBlockForm.vue';
import { InviteAdmin } from '@/store/models/jwt';
import { ValidationObserver } from 'vee-validate';
import { UserStore } from '@/store/modules';
import QvInput from '@/components/FormComponents/QvInput.vue';
import QvSelect from '@/components/FormComponents/QvSelect.vue';

@Component({
  components: {
    SvgIcon,
    ImportBlockForm,
    ValidationObserver,
    QvInput,
    QvSelect
  }
})
export default class InviteManagerPage extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  inviteAdmin: InviteAdmin[] = [{ email: '' }] as InviteAdmin[];

  addInvitation() {
    this.inviteAdmin.push({ email: '' });
  }
  removeInvitation(index: number) {
    this.inviteAdmin.splice(index, 1);
  }

  async onSubmit() {
    for (const invitation of this.inviteAdmin) {
      invitation.email = invitation.email.toLowerCase();
    }
    console.log(this.inviteAdmin);
    const response = await UserStore.inviteAdmin(this.inviteAdmin);
    this.$q.notify({
      type: 'positive',
      message: response.message
    });
    this.$router.push({ name: 'Settings' });
  }
  onReset() {
    this.inviteAdmin = [{ email: '' }] as InviteAdmin[];
    requestAnimationFrame(() => {
      this.$refs.observer.reset();
    });
  }
}
